import React from 'react';

import { Badge } from '@mantine/core';

interface VoiceBadgeProps {
  value: string;
}

export function VoiceBadge({ value }: VoiceBadgeProps) {
  return (
    <Badge color="gray.7" variant="light" size="sm" tt="capitalize">
      {value}
    </Badge>
  );
}
